import * as React from "react";
import { PartnersList as ConnectedPartnersList } from "./partners-list";

export const PartnersList = () => {
  return <ConnectedPartnersList />;
};
